import Typo from "~/components/atoms/Typo";
import CardFeature from "~/components/molecules/CardFeature";
import { IProject } from "~/entities/project";
import { ETypoTag, ETypoVariant } from "~/utilities/enums/Typo";

export interface CuratedPropertiesMobileProps {
  title: string;
  projects: IProject[];
  handleOnSelectProject?: () => void;
}

export default function CuratedPropertiesMobile({
  title,
  projects,
  handleOnSelectProject,
}: CuratedPropertiesMobileProps) {
  return (
    <div className="container-content hidden lg:block">
      <div className="flex flex-col">
        <div className="container">
          <div className="flex flex-row items-end justify-between md:gap-y-3">
            <Typo
              color="text-projectHeadingText"
              className="font-semibold lg:text-sub-title-20 lg:font-bold"
              tag={ETypoTag.H3}
              variant={ETypoVariant.HEADER_32}
            >
              {title}
            </Typo>
          </div>
        </div>
        <div className="relative mt-6 w-full overflow-y-auto overflow-x-hidden">
          {projects?.map((project, index) => {
            return (
              <div
                className="group h-auto min-h-max w-full max-w-full p-6 pt-0 lg:px-6 lg:py-4.5"
                key={project.id + index}
              >
                <CardFeature
                  full
                  project={project}
                  className="block h-full w-full max-w-full border border-solid"
                  handleOnSelectProject={handleOnSelectProject}
                  thumbnailClass="max-h-[196px]"
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
